export default __webpack_public_path__ + "static/media/wrestling.da66f5aa.png";